import React, { Component } from "react";
import ArenaDataService from "../services/arena.service";
import { withRouter } from "../common/with-router";
import Card from 'react-bootstrap/Card';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import DateHour from "./date-hour.component";
import ReplaysList from "./replays-list.component";
import QRCodeGenerator from "./qrcode-generator.component";
import SponsorsList from "./sponsors-list.component";

class Place extends Component {
  constructor(props) {
    super(props);
    this.getPlace = this.getPlace.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);

    this.state = {
      place: {},
      resetReplays: false,
      isLoading: true,
    };
  }

  componentDidMount() {
    this.getPlace(this.props.router.params.id, this.props.router.params.place);
  }

  getPlace(id, placeName) {
    ArenaDataService.getPlace(id, placeName)
      .then((response) => {
        this.setState({
          place: response.data,
          isLoading: false,
        });
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isLoading: false });
      });
  }

  handleDateChange(selectedDate) {
    this.setState({ resetReplays: true }, () => {
      this.setState({ resetReplays: false });
    });
  }

  render() {
    const { place, resetReplays, isLoading } = this.state;
    const { date, hour, id, place: placeName } = this.props.router.params;

    // Gera a URL base para o QRCode
    const qrCodeURL = `https://replaypro.com.br/arenas/${id}/${encodeURIComponent(place.arenaName)}/${encodeURIComponent(placeName)}/`;

    return (
      <div className="mt-4">
        {place.arenaId ? (
          <>
            <Breadcrumb>
              <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
              <Breadcrumb.Item href={`/arenas/${place.arenaId}/${place.arenaName}`}>
                {place.arenaName}
              </Breadcrumb.Item>
              <Breadcrumb.Item active>{place.placeName}</Breadcrumb.Item>
            </Breadcrumb>
            <h4>
              {place.arenaName} - <span>{place.placeName}</span>
            </h4>
          </>
        ) : (
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          </Breadcrumb>
        )}

        {isLoading ? (
          <div className="text-center">
            <img src="/images/loading.svg" alt="Carregando..." />
          </div>
        ) : (
          <>
            {place.arenaId && (
              <>
                <Row className="align-items-center">
                  <Col className="col-6 col-md-4 col-xl-2 pb-4 col">
                    <div>
                      <img src={`/logos/${place.arenaId}/logo.svg`} alt={`Logo`} height="105" />
                    </div>
                  </Col>
                  <Col className="col-0 d-none d-md-block col-md-4 col-xl-7 pb-4 col">
                  </Col>
                  <Col className="col-6 col-md-4 col-xl-3 pb-4 col">
                    <Card className="flex-fill">
                      <Card.Body>
                        <QRCodeGenerator qrCodeURL={qrCodeURL} />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
                <SponsorsList sponsors={place.sponsors} arenaId={place.arenaId} />
              </>
            )}
            {place.dates && place.dates.length > 0 && (
              <Row className="d-flex align-items-start">
                <Col className="col-12 col-md-4 col-xl-2 pb-4 col">
                  <DateHour
                    placeData={place}
                    selectedHour={hour}
                    onDateChange={this.handleDateChange}
                  />
                </Col>
                <Col className="col-12 col-md-8 col-xl-10 pb-4 col">
                  {!resetReplays && (
                    <ReplaysList
                      arenaId={id}
                      placeName={placeName}
                      date={date}
                      hour={hour}
                      onClearReplays={resetReplays}
                    />
                  )}
                </Col>
              </Row>
            )}

            {(!place.dates || place.dates.length === 0) && (
              <div>Não há vídeos disponíveis para este local.</div>
            )}
          </>
        )}
      </div>
    );
  }
}

export default withRouter(Place);